var render = function () {
  var _vm$currentRound;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'bits-about-it'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content",
      "id": "bits-about-it-content"
    },
    slot: "content"
  }, [_c('div', {
    class: ['shifty-targets', {
      tablet: _vm.isMobile
    }]
  }, [_c('ul', {
    staticClass: "text-steps"
  }, [_c('li', {
    class: "list-step"
  }, [_c('color-block-text', {
    attrs: {
      "text": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : _vm$currentRound.answer,
      "text-step": this.progress.stepIndex,
      "hint-class": _vm.getUppercaseHint
    }
  })], 1)])])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }